/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Changed_MeanwhileInputs */

const en_po_changed_meanwhile = /** @type {(inputs: Po_Changed_MeanwhileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This purchase order changed while you were looking at it. It has been reloaded: check it and try again.`)
};

/**
* | output |
* | --- |
* | "This purchase order changed while you were looking at it. It has been reloaded: check it and try again." |
*
* @param {Po_Changed_MeanwhileInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_changed_meanwhile = /** @type {((inputs?: Po_Changed_MeanwhileInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Changed_MeanwhileInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_changed_meanwhile(inputs)
});